module.exports = __webpack_public_path__ + "img/bottom_icon6.76f5002b_76f5002bf87fd0d4a3cabbdc9a951943.76f5002b.png";